export const isWindows = navigator.appVersion.includes("Win");
export const isEdge = navigator.appVersion.includes("Edge/");
export const isFirefox = navigator.userAgent.includes("Firefox");
export const isSafari = navigator.vendor.includes("Apple");
